// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2oD7f","controls":"styles_controls__1evkB","charLimit":"styles_charLimit__3qfJZ","input":"styles_input__Uqqrw","send":"styles_send__2lhwa"};